import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";

const DIET_TYPES = [
  { dietCode: "DIET001", dietName: "Regular Diet" },
  { dietCode: "DIET002", dietName: "Low Salt Diet" },
  { dietCode: "DIET003", dietName: "Diabetic Diet" },
  { dietCode: "DIET004", dietName: "Low Fat Diet" },
  { dietCode: "DIET005", dietName: "High Protein Diet" },
  { dietCode: "DIET006", dietName: "Soft Diet" },
  { dietCode: "DIET007", dietName: "Renal Diet" },
  { dietCode: "DIET008", dietName: "Liquid Diet" },
];

export default function DietAdvice() {
  const dispatch = useDispatch();
  const dischargeDietDtls = useSelector(
    (state) => state.discharge?.dischargeDietDtls || []
  );

  const isChecked = (dietCode) => {
    return dischargeDietDtls.some((item) => item.dietCode === dietCode);
  };

  const handleToggleDiet = (diet) => {
    const existingIndex = dischargeDietDtls.findIndex(
      (item) => item.dietCode === diet.dietCode
    );

    if (existingIndex > -1) {
      dispatch(removeDischargeArrayItem("dischargeDietDtls", existingIndex));
    } else {
      dispatch(
        addDischargeArrayItem("dischargeDietDtls", {
          dietId: dischargeDietDtls.length + 1,
          dietCode: diet.dietCode,
          dietName: diet.dietName,
          status: 1,
        })
      );
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        10. Diet Advice ({dischargeDietDtls.length} Selected)
      </h3>
      <label className="block text-xs font-semibold mb-2 text-gray-700">
        Select Diet Type
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-2.5 gap-x-2 mb-3 text-xs font-medium text-gray-700">
        {DIET_TYPES.map((diet) => {
          const checked = isChecked(diet.dietCode);
          return (
            <label
              key={diet.dietCode}
              className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggleDiet(diet)}
                className="rounded text-teal-600 focus:ring-teal-500"
              />
              <span className={checked ? "text-teal-900 font-semibold" : ""}>
                {diet.dietName}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
